module.exports = {
    TINKOFF: 'tinkoff',
    CLOUDPAYMENTS: 'cloudpayments',
    STRIPE: 'stripe',
    M3: 'm3',
    SOVKOM: 'sovkom',
}